var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex px-20 leading-none rounded-lg",style:({
    width: 'fit-content',
    margin: 'auto'
  })},[_c('div',{staticClass:"flex items-center",style:({ gap: '30px' })},[_c('div',{staticClass:"cursor-pointer",style:({ width: '2.4rem' }),on:{"click":_vm.onClick}},[_c('Menu')],1),_c('div',{staticClass:"w-20 cursor-pointer",on:{"click":_vm.closeProject}},[_c('Cross')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }